import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import { withFirebase } from '../Firebase';

const withAuthentication = Component => {
  class WithAuthentication extends React.Component {
    constructor(props) {
      super(props);

      this.props.onSetAuthUser(JSON.parse(localStorage.getItem('authUser')));
    }

    componentDidMount() {
      const { firebase } = this.props;

      this.listener = firebase.onAuthUserListener(
        authUser => {
          firebase.analytics.setUserProperties({ logged_in_user: 'true' });

          firebase.auth
            .fetchSignInMethodsForEmail(authUser.email)
            .then(activeSignInMethods => {
              authUser.activeSignInMethods = activeSignInMethods;

              localStorage.setItem('authUser', JSON.stringify(authUser));
              this.props.onSetAuthUser(authUser);
            })
            .catch(error => this.setState({ error }));
        },
        () => {
          localStorage.removeItem('authUser');
          this.props.onSetAuthUser(null);
        }
      );
    }

    componentWillUnmount() {
      this.listener();
    }

    render() {
      return <Component {...this.props} />;
    }
  }

  const mapDispatchToProps = dispatch => ({
    onSetAuthUser: authUser => dispatch({ type: 'AUTH_USER_SET', authUser })
  });

  return compose(
    withFirebase,
    connect(null, mapDispatchToProps)
  )(WithAuthentication);
};

export default withAuthentication;
